import React, { Component } from 'react'
import {Chart, registerables} from "chart.js";
import 'chartjs-adapter-luxon'
import { timeSeriesTicks } from './ChartUtils';
import {uniqueCombo} from '../Utils/linkPartners'

import "./LineGraph.css";

const linkColor = '#007ac0'

export default class LinkChart extends Component {
  constructor(props) {
    super(props);
    this.state = {
    }
    this.myLineChart = undefined;
    this.chartRef = React.createRef();
  }
  componentDidMount() {
    Chart.register(...registerables);
    const chart = this.propsToChart()
    this.buildChart(chart);
  }
  componentDidUpdate() {
    this.buildChart(this.propsToChart())
  }
  componentWillUnmount() {
    if (typeof this.myLineChart !== "undefined") 
      this.myLineChart.destroy();
  }
  propsToChart () {
    const apiData = this.props?.chartProps?.series3 ?? [] 
    const uniques = uniqueCombo(apiData) ?? []
    return apiData.map (i => uniques.findIndex(x => x?.DestAdrs === i?.DestAdrs))
  }
  buildChart = (plot) => {
    const timeconfig = timeSeriesTicks(this.props?.chartProps?.label);
    const cdata = this.pointFormat(plot)
    const yValues = uniqueCombo (this.props?.chartProps?.series3) ?? []
    //console.log (cdata, plot, this.props, Math.max(...plot), yValues)
    const chartObj = {
      defaults: {
        font: "'PT Sans', sans-serif",
      },
      data: cdata,
      options: {
        responsive: true,
        maintainAspectRatio: false,
        plugins: { legend: {display: false},
          tooltip: {
            callbacks: {
              label: function(context) {
                return context.dataset.label+" : "+yValues[context.parsed.y]?.DestAdrs ?? ' '
              }
            }
          }
        },
        scales: {
          x: {
            type: 'time',
            distribution: 'linear',
            ...timeconfig,
            ticks: { display: true },
            grid: {display: false},
          },
          y: {
            id: 'partner',
            type: 'linear',
            position: 'left',
            grace: '5%',
            ticks: { display: true,
              callback:((context, index, value) => {
              //  console.log (context, index, value)
                return this.indexable(context, yValues) ? yValues[context]?.DestAdrs :' '
              })
             },
            grid: {display: false},
            beginAtZero: false,
         },
        }
      } 
    }
    const myChartRef = this.chartRef.current.getContext("2d");
    if (typeof this.myLineChart !== "undefined") 
      this.myLineChart.destroy();
    this.myLineChart = new Chart(myChartRef, chartObj);
    return chartObj;
  }
  pointFormat (plot) {
    return ({
      datasets: [{
        label: 'Link',
        data: plot,
        borderColor: linkColor,
        fill: true,
        backgroundColor: 'transparent',
        type: 'line',
        pointStyle: 'triangle',
        pointRadius: 6,
      }],
      labels: this.props?.chartProps?.label,
    })
  }
  indexable(index, arr) {
    return index >= 0 && index < arr.length
  }
  render() {
    return (
      <div className='graphContainer'>
        <canvas id="myChart" ref={this.chartRef} />
      </div>
    )
  }
}